import { TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Dimmer, Loader, Segment } from "semantic-ui-react";
import { changeTool } from "../slices/footer/footerSlice";
import ArrayEntry from "../datatypeComponents/ArrayEntry";
import { allFevirResourceTypes } from "../dictionaries/CodeSystemLookup";
import ProfilesByResourceType from "../dictionaries/ProfilesByResourceType";
import { getSearchResultsWithIncludedResourceTypes } from "../functions/getSearchResultsAPI";
import { selectCurrentUserApiToken } from "../slices/currentUser/currentUserSlice";
import { changeBrowserTabTitle } from "../slices/browserTabTitle/browserTabTitleSlice";

const SearchQueryPage = ({ }) => {

    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    dispatch(changeBrowserTabTitle("FEvIR Search"));

    const [searchQueryState, setSearchQueryState] = useState({});
    const [currentSearchResultsState, setCurrentSearchResultsState] = useState(false);
    const [fevirSearchResultsState, setFevirSearchResultsState] = useState([]);
    const [searchResultsLoadingState, setSearchResultsLoadingState] = useState(false);
    const [resourceTypeValuesState, setResourceTypeValuesState] = useState([]);
    const [profileValuesState, setProfileValuesState] = useState([]);
    const [includedResourceTypeValuesState, setIncludedResourceTypeValuesState] = useState([]);
    const [selectedResourceTypeValuesState, setSelectedResourceTypeValuesState] = useState({ resourceTypeLimiter: [] });

    useEffect(() => {
        dispatch(changeTool("FevirSearch"));
        setResourceTypeValuesState(allFevirResourceTypes);
    }, []);

    useEffect(() => {
        if (searchQueryState.resourceTypeLimiter?.length) {
            let availableProfiles = [];
            for (const resourceType of searchQueryState.resourceTypeLimiter) {
                if (ProfilesByResourceType[resourceType]) {
                    availableProfiles = availableProfiles.concat(Object.keys(ProfilesByResourceType[resourceType]));
                }
            }
            if (availableProfiles.length) {
                setProfileValuesState(availableProfiles);
            }
        }
    }, [searchQueryState.resourceTypeLimiter]);

    const processSearchSelections = async () => {
        if (searchResultsLoadingState) {
            setCurrentSearchResultsState(false);
            let selectedResourceType;
            if (searchQueryState.resourceTypeLimiter?.length === 1) {
                selectedResourceType = searchQueryState.resourceTypeLimiter[0];
            }
            let selectedProfile;
            if (searchQueryState.selectedProfiles?.length === 1) {
                selectedProfile = searchQueryState.selectedProfiles[0];
            }
            let resourceTypeLimiter;
            if (selectedResourceTypeValuesState.resourceTypeLimiter.length > 0) {
                resourceTypeLimiter = selectedResourceTypeValuesState.resourceTypeLimiter;
            } else {
                resourceTypeLimiter = searchQueryState.resourceTypeLimiter;
            }

            let [searchResults, includedResourceTypeValues] = await getSearchResultsWithIncludedResourceTypes(searchQueryState.simpleString,
                selectedResourceType,
                resourceTypeLimiter,
                selectedProfile,
                searchQueryState.selectedProfiles,
                apiToken);

            setFevirSearchResultsState(searchResults);
            setIncludedResourceTypeValuesState(includedResourceTypeValues);
            setCurrentSearchResultsState(true);
            setSearchResultsLoadingState(false);
        }
    }

    useEffect(() => {
        processSearchSelections();
    }, [searchResultsLoadingState]);

    const searchClick = () => {
        setFevirSearchResultsState([]);
        setSearchResultsLoadingState(true);
    }

    const handleKeyUp = (event) => {
        //replace !globalContext.alertModalState.open with a slice for alertModal and way to check
        //if (event.key === 'Enter' && !globalContext.alertModalState.open) {
        //  searchClick();
        //}    WHEN WOULD THIS BE A CONCERN?
        if (event.key === 'Enter') {
            searchClick();
        }
    }

    return <div>
        <Segment className={`containerSegment maxRemainderOfPageSegment`} raised textAlign="left">
            <TextField className="inputField" type="text" size="small"
                style={{ width: "75%" }}
                label="Simple Search String" variant="outlined"
                value={searchQueryState.simpleString || ""} onKeyUp={handleKeyUp}
                onChange={(e) => { setSearchQueryState(prevState => { return { ...prevState, "simpleString": e.target.value } }); }}
            />
            <br /><br />
            {resourceTypeValuesState.length ?
                <>
                    <ArrayEntry datatype='code' elementName='resourceTypeLimiter' fieldLabel='Limit by Resource Type'
                        allowedValues={resourceTypeValuesState} dataEntryStyle='dropdownsearch'
                        startingValue={searchQueryState.resourceTypeLimiter || []}
                        setResourceState={setSearchQueryState} />
                    <p style={{ paddingTop: "12px" }}>Limit to resource types of: {(searchQueryState.resourceTypeLimiter &&
                        searchQueryState.resourceTypeLimiter.length > 0) ?
                        searchQueryState.resourceTypeLimiter.join(', ') : "[No limits]"}</p>
                    <br />
                </>
                :
                <Dimmer className={"loadingDimmer"} active inverted>
                    <Loader inverted>Loading</Loader>
                </Dimmer>
            }
            {profileValuesState.length ?
                <>
                    <ArrayEntry datatype='code' elementName='selectedProfiles' fieldLabel='Limit by Profile'
                        allowedValues={profileValuesState.sort()}
                        dataEntryStyle='dropdownsearch'
                        startingValue={searchQueryState.selectedProfiles || []}
                        setResourceState={setSearchQueryState} />
                    <p style={{ paddingTop: "12px" }}>
                        Limit to Profiles of: {(searchQueryState.selectedProfiles &&
                            searchQueryState.selectedProfiles.length > 0) ?
                            searchQueryState.selectedProfiles.join(', ') : "[No limits]"}</p>
                    <br />
                </>
                :
                <></>
            }
            <span>
                <Button style={{ color: "#000000", width: "360px", float: "left" }}
                    className="formButton"
                    content="Search"
                    onClick={searchClick} />
            </span>
            <br />   <br />
            {searchResultsLoadingState ?
                <><img style={{ height: "22px" }} src="/spinner.gif" alt="Loading" /> Loading...</>
                :
                <div style={{ marginTop: "18px" }}>
                    {(fevirSearchResultsState.length > 0 && currentSearchResultsState) && <>
                        <p>
                            {fevirSearchResultsState.length} FEvIR search results.
                        </p>
                        <ArrayEntry datatype='code' elementName='resourceTypeLimiter'
                            fieldLabel='Limit Results by Resource Type'
                            allowedValues={includedResourceTypeValuesState} dataEntryStyle='dropdownsearch'
                            startingValue={selectedResourceTypeValuesState.resourceTypeLimiter || []}
                            setResourceState={setSelectedResourceTypeValuesState} />
                        <br />
                        {fevirSearchResultsState.map((result, resultIndex) => {
                            return <p key={resultIndex}>
                                <a href={"https://fevir.net" + result.onClick} >{result.display}</a>
                            </p>
                        })}
                    </>}
                    {(!(fevirSearchResultsState.length > 0) && currentSearchResultsState) &&
                        "No matching entries on FEvIR Platform."}
                </div>
            }
        </Segment>
    </div>
}

export default SearchQueryPage;